// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner-ads_banner__3j-ZD","bannersContainer":"banner-ads_bannersContainer__2ePVx"};